/* eslint-disable camelcase */
import PropTypes from 'prop-types'
import React from 'react'
import i18n from 'simple-react-i18n'
import DtoInstallationBorehole from '../../../../dto/borehole/DtoInstallationBorehole'
import { Card, CardContent, Grid } from '@mui/material'
import NumberField from 'components/forms/NumberField'
import StationDescriptionTable from 'station/components/link/StationDescriptionTable'
import SimpleTextArea from 'components/forms/SimpleTextArea'

const headers = ['diameterSymbol', 'depth', 'comment']

const DrillingDialogContent = ({
    stateElement,
    onChangeElement = () => { },
}) => {
    return (
        <Card>
            <CardContent>
                <Grid container columnSpacing={1}>
                    <Grid size={6}>
                        <NumberField
                            value={stateElement.order}
                            title={i18n.order}
                            onChange={v => onChangeElement({ order: v })}
                        />
                    </Grid>
                    <Grid size={6}>
                        <NumberField
                            value={stateElement.diameter}
                            title={i18n.diameter}
                            onChange={v => onChangeElement({ diameter: v })}
                            floatValue
                        />
                    </Grid>
                    <Grid size={6}>
                        <NumberField
                            value={stateElement.depth}
                            title={i18n.depth}
                            onChange={v => onChangeElement({ depth: v })}
                            floatValue
                        />
                    </Grid>
                    <Grid size={12}>
                        <SimpleTextArea
                            value={stateElement.comment}
                            title={i18n.comment}
                            onChange={v => onChangeElement({ comment: v })}
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}

DrillingDialogContent.propTypes = {
    stateElement: PropTypes.object,
    onChangeElement: PropTypes.func,
}

const BoreholeDrillingTable = ({
    borehole = {},
    readMode = false,
    onChange = () => { },
}) => {
    return (
        <StationDescriptionTable
            station={borehole}
            readMode={readMode}
            onChange={onChange}
            keyList='link_drillings'
            formatFunction={c => ({
                ...c,
                diameterSymbol: c.diameter,
            })}
            titles={{
                title: i18n.drillings,
                edit: i18n.drillings,
                new: i18n.new,
            }}
            headers={headers}
            dialogContent={DrillingDialogContent}
        />
    )
}

BoreholeDrillingTable.propTypes = {
    borehole: PropTypes.instanceOf(DtoInstallationBorehole),
    readMode: PropTypes.bool,
    onChange: PropTypes.func,
}

export default BoreholeDrillingTable